import moment from "moment";
import "moment/locale/ko";

import CryptoJS from "crypto-js";
import { PayHelper, servicePWcrypto } from "../scCommon/scCommonFunc";

import {
  GetServiceSetData,
  GetSubscriptionSetData,
  GetRewardSetData,
  getMaxSavedMonthlyMoneyBySubs,
} from "./ServiceDatas";

import { getLocaleInfo } from "../Config";
import { PayReason, PState, PMState, CPState } from "./Types";

import SystemSet from "../datafiles/system_set.json";
import { GetStringByKey, GetStringByKeyValues } from "./ApiTranslate";
import { ApiBase64 } from "./ApiBase64";
import { getNowMomentByServerTime } from "../ApiTS/ApiCommonTS";

//계좌 코드에 맞는 은행이름을 리턴한다. (쇼트 네임)
export const GetBankNameByBankCode = (bankcode) => {
  let bankName = "";
  switch (bankcode) {
    case "004":
      bankName = "KB국민";
      break;
    case "023":
      bankName = "SC제일";
      break;
    case "039":
      bankName = "경남";
      break;
    case "034":
      bankName = "광주";
      break;
    case "003":
      bankName = "IBK기업";
      break;
    case "011":
      bankName = "NH농협";
      break;
    case "031":
      bankName = "대구";
      break;
    case "032":
      bankName = "부산";
      break;
    case "002":
      bankName = "KDB산업";
      break;
    case "045":
      bankName = "새마을";
      break;
    case "007":
      bankName = "Sh수협";
      break;
    case "088":
      bankName = "신한";
      break;
    case "048":
      bankName = "신협";
      break;
    case "005":
      bankName = "외환은행";
      break;
    case "020":
      bankName = "우리";
      break;
    case "071":
      bankName = "우체국";
      break;
    case "037":
      bankName = "전북";
      break;
    case "090":
      bankName = "카카오뱅크";
      break;
    case "089":
      bankName = "케이뱅크";
      break;
    case "081":
      bankName = "하나";
      break;
    case "027":
      bankName = "시티";
      break;
    case "092":
      bankName = "토스";
      break;
    case "035":
      bankName = "제주";
      break;
    default:
      bankName = "";
      break;
  }

  return bankName;
};

//계좌 코드에 맞는 풀 은행이름을 리턴한다. (풀 네임)
export const GetBankFullNameByBankCode = (bankcode) => {
  let bankName = "";
  switch (bankcode) {
    case "004":
      bankName = "KB국민은행";
      break;
    case "023":
      bankName = "SC제일은행";
      break;
    case "039":
      bankName = "경남은행";
      break;
    case "034":
      bankName = "광주은행";
      break;
    case "003":
      bankName = "IBK기업은행";
      break;
    case "011":
      bankName = "NH농협은행";
      break;
    case "031":
      bankName = "대구은행";
      break;
    case "032":
      bankName = "부산은행";
      break;
    case "002":
      bankName = "KDB산업은행";
      break;
    case "045":
      bankName = "새마을금고";
      break;
    case "007":
      bankName = "Sh수협은행";
      break;
    case "088":
      bankName = "신한은행";
      break;
    case "048":
      bankName = "신협";
      break;
    case "005":
      bankName = "외환은행";
      break;
    case "020":
      bankName = "우리은행";
      break;
    case "071":
      bankName = "우체국";
      break;
    case "037":
      bankName = "전북은행";
      break;
    case "090":
      bankName = "카카오뱅크";
      break;
    case "089":
      bankName = "케이뱅크";
      break;
    case "081":
      bankName = "하나은행";
      break;
    case "027":
      bankName = "시티은행";
      break;
    case "092":
      bankName = "토스뱅크";
      break;
    case "035":
      bankName = "제주은행";
      break;
    default:
      bankName = "";
      break;
  }

  return bankName;
};

//은행 계좌가 저장 값이유효한지.
export const CheckUserBankAccountValid = (user) => {
  if (user && user.userData) {
    if (user.userData.bankname !== "" && user.userData.banknumber !== "") {
      return true;
    }
  }
  return false;
};

//카드 정보 저장 값이 유효한지.
export const CheckUserCardValid = (user) => {
  if (user && user.userData) {
    if (
      user.cardInfo &&
      user.cardInfo.cardName !== "" &&
      user.cardInfo.cardNumber !== ""
    ) {
      return true;
    } else if (
      user.userData.cardname !== "" &&
      user.userData.cardnumber !== ""
    ) {
      return true;
    }
  }
  return false;
};
export const GetServiceSetServiceNameByNumber = (servID) => {
  let serviceName = "";
  switch (servID) {
    case 1:
      serviceName = "Netflix";
      break;
    case 3:
      serviceName = "Wavve";
      break;
    case 2:
      serviceName = "Watcha";
      break;
    case 4:
      serviceName = "Tving";
      break;
    case 5:
      serviceName = "Disney";
      break;
    case 6:
      serviceName = "Spotify";
      break;
    case 7:
      serviceName = "Tidal";
      break;
    case 8:
      serviceName = "Office365";
      break;
    case 9:
      serviceName = "Adobe";
      break;
    default:
      break;
  }
  return serviceName;
};

export const GetServiceSetNumberByServiceName = (serviceName) => {
  let serviceID = 0;
  switch (serviceName) {
    case "Netflix":
      serviceID = 1;
      break;
    case "Wavve":
      serviceID = 3;
      break;
    case "Watcha":
      serviceID = 2;
      break;
    case "Tving":
      serviceID = 4;
      break;
    case "Disney":
      serviceID = 5;
      break;

    case "Spotify":
      serviceID = 6;
      break;
    case "Tidal":
      serviceID = 7;
      break;
    case "Office365":
      serviceID = 8;
      break;
    case "Adobe":
      serviceID = 9;
      break;
    default:
      break;
  }
  return serviceID;
};

// 링키드 머니 가져오기
export const GetCurrentLinkidMoney = (user, isJustValue) => {
  if (user && user.userData && user.userData.money) {
    if (isJustValue) {
      return user.userData.money;
    } else {
      return GetMoneyValue(user.userData.money);
    }
  }

  if (isJustValue) {
    return 0;
  } else {
    return GetMoneyValue(0);
  }
};

// 숫자 키패드 섞기
export const GetRandomKeypadNumber = () => {
  let array = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

  for (let i = 0; i < array.length; i++) {
    let j = Math.floor(Math.random() * (i + 1));
    // [array[i], array[j]] = [array[j], array[i]];
    const x = array[i];
    array[i] = array[j];
    array[j] = x;
  }
  return array;
};

// 로그인을 했는지 여부
export const getNowLogined = (user) => {
  let logined = false;
  if (user && user.loginSuccess && user.loginSuccess.result === 0) {
    logined = true;
  }
  return logined;
};

// 파티 시작일, 종료일로 구하는현재 상태
export const getPartyStatusByDate = (sDate, eDate) => {
  const modifiedNow = getNowMomentByServerTime();

  const diffTodayWithStartDate = moment(sDate).diff(
    // moment().format("YYYY-MM-DD"),
    modifiedNow,
    "days"
  );
  const diffTodayWithEndDate = moment(eDate).diff(
    // moment().format("YYYY-MM-DD"),
    modifiedNow,
    "days"
  );
  if (diffTodayWithEndDate < 0) {
    return "expired"; //만료 됨!
  } else {
    if (diffTodayWithStartDate <= 0) {
      return "progressive"; //진행 중!
    } else {
      return "before"; //아직 시작 안함!
    }
  }
};

//  서버에서 주는 값으로 구하는 현재 파티 상태

// 날짜 간격 구하기
export const getDiffDay = (fromDate, ToDate) => {
  return moment(ToDate).diff(moment(fromDate).format("YYYY-MM-DD"), "days");
};

//암호화.
export const encryptPW = (pw, uid) => {
  const pwJson = JSON.stringify(pw);
  var key = CryptoJS.enc.Utf8.parse(servicePWcrypto.Key(uid));
  var iv = CryptoJS.enc.Utf8.parse(servicePWcrypto.IV);
  var aesEncryptor = CryptoJS.algo.AES.createEncryptor(key, { iv: iv });

  var ddd = aesEncryptor.process(pwJson);

  var final = aesEncryptor.finalize();

  return ddd.toString(CryptoJS.enc.Hex) + final.toString(CryptoJS.enc.Hex);
};

//복호화.
export const decryptPW = (pw, uid) => {
  try {
    var key = CryptoJS.enc.Utf8.parse(servicePWcrypto.Key(uid));
    var iv = CryptoJS.enc.Utf8.parse(servicePWcrypto.IV);
    var aesDecryptor = CryptoJS.algo.AES.createDecryptor(key, { iv: iv });

    var ddd = aesDecryptor.process(CryptoJS.enc.Hex.parse(pw));
    var final = aesDecryptor.finalize();

    const decValue =
      ddd.toString(CryptoJS.enc.Utf8) + final.toString(CryptoJS.enc.Utf8);

    if (IsJsonString(decValue)) {
      return JSON.parse(decValue);
    } else {
      return decValue;
    }
  } catch (error) {
    return false;
  }
};

export function IsJsonString(str) {
  try {
    var json = JSON.parse(str);
    return typeof json === "object";
  } catch (e) {
    return false;
  }
}

// 약 n 개월 구하기
export const getAboutMonth = (remainday) => {
  let month = Math.floor(remainday / 30);
  let day = remainday - month * 30;

  //남은 달 계산. 남은 달의 남은일수가 16이상이면 + 1
  if (day > 15) {
    return month + 1;
  } else {
    return month;
  }
};

export const getDayOfWeekTextKor = (i) => {
  let dowText = "";
  switch (i) {
    case 0:
      dowText = "일";
      break;
    case 1:
      dowText = "월";
      break;
    case 2:
      dowText = "화";
      break;
    case 3:
      dowText = "수";
      break;
    case 4:
      dowText = "목";
      break;
    case 5:
      dowText = "금";
      break;
    case 6:
      dowText = "토";
      break;
  }

  return dowText;
};

// 파티 생성, 가입, 요청 시도 시 내 파티 리스트와 확인해서 가능한 상태인지를 리턴한다.
export const getServiceTakeableData = (myAllPartyList, servID) => {
  // noUsing, using, requested, endSoon

  // console.log(myAllPartyList);

  let data = {
    status: "noUsing",
    endDate: "",
    requestedSubsID: 0,
    pid: 0,
  };

  if (myAllPartyList === undefined || myAllPartyList === null) return data;

  const pList = myAllPartyList?.party;
  const reqPList = myAllPartyList?.partyreq;
  const uplusList = myAllPartyList?.uplus;
  const ServiceData = GetServiceSetData(servID);

  // 1. 요청 리스트에서 찾는다.
  if (reqPList) {
    for (let i = 0; i < reqPList.length; i++) {
      const SubsData = GetSubscriptionSetData(reqPList[i].servsubsid)[0];
      if (SubsData && SubsData.SVC_ID !== undefined) {
        // 같은 서비스를 찾고
        if (ServiceData[0].SVC_ID === SubsData.SVC_ID) {
          data.status = "requested";
          data.requestedSubsID = SubsData.SUBS_ID;
          return data;
        }
      }
    }
  }

  // 2. 유플러스  리스트에서 찾는다.
  if (uplusList) {
    for (let i = 0; i < uplusList?.length; i++) {
      const SubsData = GetSubscriptionSetData(900000)[0];
      if (SubsData && SubsData.SVC_ID !== undefined) {
        // 같은 서비스를 찾고
        if (ServiceData[0].SVC_ID === SubsData.SVC_ID) {
          const status = uplusList[i].status;
          // 1.  매칭중
          // 2. 결합중
          // 3. 파티중
          // 4. 종료
          if (status === 4) {
            continue;
          } else {
            data.status = "using";
            data.endDate = "9999-12-31";
          }

          return data;
        }
      }
    }
  }

  // 3. 파티 리스트에서 찾는다.
  if (pList) {
    for (let i = 0; i < pList.length; i++) {
      const SubsData = GetSubscriptionSetData(pList[i].servsubsid)[0];
      if (SubsData && SubsData.SVC_ID !== undefined) {
        // 같은 서비스를 찾고
        if (ServiceData[0]?.SVC_ID === SubsData?.SVC_ID) {
          const tState = pList[i]?.mystate ?? 8;

          // 탈퇴, 숨기기, 해산, 종료 상태 서비스는 가입.생성이 가능하다.
          if (
            tState === CPState.CPS_Exited || //탈퇴 상태
            tState === PState.hidden || // 종료나 해산, 탈퇴 후 감추기 된 상태
            tState === CPState.CPS_Broken || //해산 상태
            tState === CPState.CPS_Ended || // 종료 상태.
            tState === CPState.CPS_ExitReady || //탈퇴 대기
            tState === CPState.CPS_BreakReady //해산 대기
          )
            continue;

          // 남은 날을 구하고,
          const remainDay = getDiffDay(
            moment(),
            moment(pList[i].enddate).add(-1, "d")
          );

          // 29일 이상 남았으면 생성이 불가하다.
          // (30일로 설정시 파티 가입시 날짜 검색 불가능한 케이스가 생겨 29일로 바꿈)
          if (remainDay >= 29) {
            data.status = "using";
            data.pid = pList[i].partyid;
          } else {
            if (
              pList.find((val) => val.parentpid === pList[i].partyid) !==
              undefined
            ) {
              // 연장한 파티다.
              data.status = "using";
              data.pid = pList[i].partyid;
            } else if (
              pList.find(
                (val) =>
                  val.serv === pList[i].serv &&
                  GetCurrentPartyState(
                    false,
                    val.mstate,
                    val.state,
                    val.startdate,
                    val.enddate
                  ) === CPState.CPS_Before
              ) !== undefined
            ) {
              // 예정 파티가 있다.
              data.status = "using";
              data.pid = pList[i].partyid;
            } else {
              data.status = "endSoon";
              data.endDate = pList[i].enddate;
              data.pid = pList[i].partyid;
            }
          }
          break;
        }
      }
    }
  }

  return data;
};

export const GetPayReasonStrByReasonID = (reason, isHost) => {
  // 1 파티 요금 결제
  // 2 파티 요금 결제(정산일)
  // 3 파티 위약금 결제
  // 4 파티 보증금 거치

  // 51	파티 종료 적립(정상)
  // 52	파티 보상금 적립
  // 53	파티 요금 적립(정산일)
  // 54	파티 종료 적립(탈퇴)
  // 55	파티 종료 적립(해산)

  // 101 인출
  // 102 링키드 머니 차감 (어드민)
  // 103 링키드 머니 충전 (어드민)

  let str = "";
  switch (reason) {
    case PayReason.Ch_PartyFee: // 1: 파티 요금 결제
      str = GetStringByKey(200025);
      break;
    case PayReason.Ch_PartyFee_PayDay: // 2: 파티 요금 결제 (정산일)
      str = GetStringByKey(200025);
      break;
    case PayReason.Ch_PenaltyFee: // 3: 파티 위약금 결제
      str = isHost ? GetStringByKey(200032) : GetStringByKey(200026);
      break;
    case PayReason.Ch_GuaranteeFee: // 4: 파티 보증금 거치
      str = GetStringByKey(200030);
      break;
    case PayReason.Re_EndRew: // 51: 파티 종료 적립 (정상)
      str = GetStringByKey(200027);
      break;
    case PayReason.Re_Compensation: // 52: 파티 보상금 적립
      str = GetStringByKey(200040);
      break;
    case PayReason.Re_PartyFee_PayDay: // 53: 파티 요금 적립 (정산일)
      str = GetStringByKey(200031);
      break;
    case PayReason.Re_EndRew_Exit: // 54: 파티 종료 적립 (중도 탈퇴)
      str = GetStringByKey(200029);
      break;
    case PayReason.Re_EndRew_Break: // 55: 파티 종료 적립 (중도 해산)
      str = GetStringByKey(200028);
      break;
    case PayReason.Re_PartyFee_PartyEnd: // 56: 파티 요금 적립 (종료 파티)
      str = GetStringByKey(200031);
      break;
    case PayReason.Re_PartyFee_PartyEnd_Sset: // 57: 파티 요금 적립 (종료 파티 선셋)
      str = GetStringByKey(200027);
      break;
    case PayReason.WithDraw: // 101: 인출
      str = GetStringByKey(200041);
      break;
    case PayReason.Admin_Cut_Money: // 102: 링키드 머니 차감 (어드민)
      str = GetStringByKey(200071);
      break;
    case PayReason.Admin_Charge_Money: // 103: 링키드 머니 충전 (어드민)
      str = GetStringByKey(200070);
      break;
    default:
      break;
  }
  return str;
};

export const GetMoneyValue = (value) => {
  switch (getLocaleInfo()) {
    case "kokr":
      {
        if (value !== undefined) {
          if (value < 0) {
            return "원";
          }
          return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "원";
        }
      }
      break;
    case "koen":
      {
        if (value !== undefined) {
          if (value < 0) {
            return "₩";
          }
          return "₩" + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
      }
      break;
    default:
      break;
  }
};

export const GetPartyStateFromServer = (mstate, pstate, grade, isSlot) => {
  // mstate
  // 0	정상
  // 1	탈퇴 신청중
  // 2	탈퇴 완료
  // 3	미결제

  // pstate
  // hidden	안보이기	-1
  // using	정상	0
  // broken	해산	1
  // ended	종료	2
  // breaking	해산대기	3

  // grade
  // 0	파티장
  // 1	파티원

  // 최종
  // 멤버로써
  //0 정상 , 1 탈퇴 신청 중, 2 탈퇴 완료 , 3 미결제
  // 파티 로써
  // -1 감추기 ,0 정상, 1 해산, 2 종료, 3 해산대기,

  if (isSlot) {
  } else {
    //  파티 장이면,
    if (grade === 0) {
    }
    // 파티 원 이면,
    else {
    }
  }
};

// 파티 생성/ 파티 가입 시 최대 리워드 값을 계산한다.
export const GetRewCalcValue = (
  isHost,
  memcnt,
  subsid,
  startdate,
  enddate,
  joindate,
  _type
) => {
  const SubsData = GetSubscriptionSetData(subsid)[0];
  const RwdData = GetRewardSetData(SubsData.REW_ID)[0];

  // 남은 결제일 횟수를 구한다.
  let mPstart = startdate instanceof moment ? startdate : moment(startdate);
  const mend = enddate instanceof moment ? enddate : moment(enddate);
  const mjoin = joindate instanceof moment ? joindate : moment(joindate);

  // console.log(isHost, memcnt, subsid, startdate, enddate, joindate, _type)

  if (mPstart < mjoin) mPstart = mjoin;

  let retCount = 0;
  const period = mend - mPstart;

  if (_type == "day") {
    retCount = moment.duration(period).asDays();
  } else if (_type == "week") {
    retCount = moment.duration(period).asWeeks();
  } else if (_type == "month") {
    retCount = moment.duration(period).asMonths();
  } else {
    retCount = moment.duration(period).asYears();
  }

  // console.log(SubsData, retCount)
  const retFinal = PayHelper.get_maxrewardstep_compare_inputperiod(
    RwdData,
    retCount
  );

  let value = 0;
  if (isHost) {
    value = parseInt(
      SubsData.SUBS_FEE *
      memcnt *
      (SubsData.COMM_LDRRT / 10000) *
      (RwdData[parseInt(retFinal)] / 10000) *
      retFinal
    );
  } else {
    value = parseInt(
      SubsData.SUBS_FEE *
      (SubsData.COMM_MBRRT / 10000) *
      (RwdData[parseInt(retFinal)] / 10000) *
      retFinal
    );
  }

  if (isNaN(value)) {
    value = 0;
  }

  return value;
};

// 남은 기간동안 받을수 있는 리워드 값을 계산한다.
export const GetFutureRewCalcValue = (
  isHost,
  memcnt,
  subsid,
  _type,
  payday,
  startdate,
  enddate,
  joindate
) => {
  const SubsData = GetSubscriptionSetData(subsid)[0];
  const RwdData = GetRewardSetData(SubsData.REW_ID)[0];

  //결제일 기준으로 직전 결제일을 구한다.
  const today = moment(moment().format("YYYY-MM-DD"));
  let payDay = moment(moment().format("YYYY-MM-") + payday, "YYYY-MM-DD");
  const nextPday = PayHelper.nextpdate(payday);

  let sPday;
  if (payDay <= today) {
    sPday = nextPday;
  } else {
    sPday = today;
  }
  // console.log(sPday)
  // console.log(_type, enddate)
  // 남은 결제일 횟수를 구한다.
  let mPstart = sPday instanceof moment ? sPday : moment(sPday);
  const mend = enddate instanceof moment ? enddate : moment(enddate);

  let retCount = 0;
  const period = mend - mPstart;

  if (_type == "day") {
    retCount = moment.duration(period).asDays();
  } else if (_type == "week") {
    retCount = moment.duration(period).asWeeks();
  } else if (_type == "month") {
    retCount = moment.duration(period).asMonths();
  } else {
    retCount = moment.duration(period).asYears();
  }

  // 마지막달은 1로 보정.
  if (retCount < 1) {
    retCount = 1;
  }
  retCount = parseInt(retCount);

  // 시작일과 (파티원이면 가입일) 종료일 간의 개월수를 구한다.
  let mstart = startdate instanceof moment ? startdate : moment(startdate);
  const mjoin = joindate instanceof moment ? joindate : moment(joindate);

  if (mstart < mjoin) mstart = mjoin;

  let retCountS = 0;
  const period2 = mend - mstart;

  if (_type == "day") {
    retCountS = moment.duration(period2).asDays();
  } else if (_type == "week") {
    retCountS = moment.duration(period2).asWeeks();
  } else if (_type == "month") {
    retCountS = moment.duration(period2).asMonths();
  } else {
    retCountS = moment.duration(period2).asYears();
  }

  const retFinal = PayHelper.get_maxrewardstep_compare_inputperiod(
    RwdData,
    retCountS
  );

  // 최종 값을 구한다.
  let value = 0;
  if (isHost) {
    value = parseInt(
      SubsData.SUBS_FEE *
      memcnt *
      (SubsData.COMM_LDRRT / 10000) *
      (RwdData[parseInt(retFinal)] / 10000) *
      retCount
    );
  } else {
    value = parseInt(
      SubsData.SUBS_FEE *
      (SubsData.COMM_MBRRT / 10000) *
      (RwdData[parseInt(retFinal)] / 10000) *
      retCount
    );
  }

  return value;
};

// 총 얼마를 아끼고 있는지.
export const GetSavingMoneyTotal = (partyList) => {
  let value = 0;
  for (let i = 0; i < partyList.length; i++) {
    const data = partyList[i];
    const SubsData = GetSubscriptionSetData(data.servsubsid)[0];
    if (SubsData !== undefined) {
      const sDate = data.grade === 0 ? data.startdate : data.joindate;
      const period = PayHelper.calc_period(
        SubsData.SUBS_SHARTM,
        data.startdate,
        data.enddate,
        sDate
      );
      const maxSavePerMonth = getMaxSavedMonthlyMoneyBySubs(
        data.servsubsid,
        data.grade === 0 ? true : false
      );
      const maxSaveForAll =
        getMaxSavedMonthlyMoneyBySubs(
          data.servsubsid,
          data.grade === 0 ? true : false
        ) * period;
      value = value + maxSaveForAll;
    }
  }
  return value;
};

//월 단위로 얼마나 아끼고 있는지.
export const GetSavingMoneyPerMonth = (partyList) => {
  let value = 0;
  for (let i = 0; i < partyList.length; i++) {
    const data = partyList[i];
    //   console.log(data)
    const SubsData = GetSubscriptionSetData(data.servsubsid)[0];
    if (SubsData !== undefined) {
      const sDate = data.grade === 0 ? data.startdate : data.joindate;
      const period = PayHelper.calc_period(
        SubsData.SUBS_SHARTM,
        data.startdate,
        data.enddate,
        sDate
      );
      const maxSavePerMonth = getMaxSavedMonthlyMoneyBySubs(
        data.servsubsid,
        data.grade === 0 ? true : false
      );
      // const maxSaveForAll = getMaxSavedMonthlyMoneyBySubs(data.servsubsid)*period;
      value = value + maxSavePerMonth;
    }
  }
  return value;
};

//   CPS_Before  :           1,
//     CPS_Requested :      2,
//     CPS_ExitReady:        3,
//     CPS_Exited :             4,
//     CPS_BreakReady:     5,
//     CPS_Broken :            6,
//     CPS_Ended  :            7,
//     CPS_Using   :            8

export const GetCurrentPartyState = (isReq, mState, pState, sDay, eDay) => {
  const dateState = getPartyStatusByDate(sDay, eDay);

  if (dateState === "before" && pState === PState.using) {
    // if(dateState === "before"){
    return CPState.CPS_Before; // 예정파티
  } else if (isReq) {
    return CPState.CPS_Requested; //요청 중 파티
  } else if (mState === PMState.exitReady) {
    return CPState.CPS_ExitReady; //탈퇴 대기 파티
  } else if (mState === PMState.exited) {
    return CPState.CPS_Exited; //탈퇴 한 파티
  } else if (pState === PState.breaking) {
    return CPState.CPS_BreakReady; //해산 대기 파티
  } else if (pState === PState.broken) {
    return CPState.CPS_Broken; //해산 된 파티
  } else if (pState === PState.ended) {
    return CPState.CPS_Ended; // 종료 된 파티
  } else if (pState === PState.using) {
    return CPState.CPS_Using; //정상 운영 파티
  }
};

export const GetNowValidPartyLists = (partyList) => {
  let validPartyList = [];
  for (let i = 0; i < partyList.length; i++) {
    const state = partyList[i]?.mystate ?? 8;

    //   if(state === CPState.CPS_ExitReady || state === CPState.CPS_BreakReady || state === CPState.CPS_Using){
    if (state === CPState.CPS_Using) {
      validPartyList.push(partyList[i]);
    }
  }

  return validPartyList;
};

export const GetNowExitOrBreakReadyPartyLists = (partyList) => {
  let notValidPartyList = [];
  for (let i = 0; i < partyList.length; i++) {
    const state = partyList[i]?.mystate;

    if (state === CPState.CPS_ExitReady || state === CPState.CPS_BreakReady) {
      notValidPartyList.push(partyList[i]);
    }
  }

  return notValidPartyList;
};

export const ReplaceStrAt = (str, index, character) => {
  const Str = String(str);
  return (
    Str.substr(0, index) + character + Str.substr(index + character.length)
  );
};

// 시스템 세팅 데이터
export const GetSystemSetData = () => {
  return SystemSet[0];
};

export const CheckIsLimitWebPlatform = (servid, isMake) => {
  let isLimitedPlatform = false;

  const ServData = GetServiceSetData(servid)[0];
  if (ServData) {
    if (isMake && ServData.SVC_LMTPF !== null) {
      const limits = ServData.SVC_LMTPF.split(",");
      for (let i = 0; i < limits.length; i++) {
        if (limits[i] === "web") {
          isLimitedPlatform = true;
          break;
        }
      }
    } else if (!isMake & (ServData.SVC_LMTFIND !== null)) {
      const limits = ServData.SVC_LMTFIND.split(",");
      for (let i = 0; i < limits.length; i++) {
        if (limits[i] === "web") {
          isLimitedPlatform = true;
          break;
        }
      }
    }
  }
  return isLimitedPlatform;
};

// 공유이메일, 아이디 타입, 프로필닉네임 정보를 로드한다.
export const GetSplitMyPartyAccInfo = (accInfo) => {
  var parsed;

  try {
    parsed = JSON.parse(accInfo);
    // debugger
    let value = {
      id: parsed?.shareid ?? parsed,
      idType: parsed?.idtype ?? "",
      profileName: parsed?.profileName ?? "",
      ldrPday: parsed?.ldrPday ?? 0,
      agList: parsed?.agList ?? [], //가입/생성시 동의한 리스트 (agreement_set.json 의 INDEX 값)
      srise: parsed?.srise ?? 0,
      old: parsed?.old ?? 0, // 연장파티가입 or 선라이즈 파티가입자는 1
    };
    return value;
  } catch (e) {
    if (e instanceof SyntaxError) {
      // 옛날 파싱 /T/
      const data = accInfo?.split("/T/") ?? [];

      let value = {
        id: data?.[0] ?? "",
        idType: data?.[1] ? data[1] : "",
        profileName: "",
        ldrPday: 0,
        agList: [],
        srise: 0,
        old: 0,
      };
      return value;
    }
  }
};

// 비밀번호 마스킹
export const GetMakeHideStringByLength = (str) => {
  let value = "";

  if (str) {
    for (let i = 0; i < str.length; i++) {
      value = value + "*";
    }
    return value;
  }
};

// 한국식 만나이 계산리턴.
export const GetKoreanAge = (birth) => {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  if (month < 10) month = "0" + month;
  if (day < 10) day = "0" + day;
  var monthDay = month + day;
  birth = birth.replace("-", "").replace("-", "");
  var birthdayy = birth.substr(0, 4);
  var birthdaymd = birth.substr(4, 4);
  var age = monthDay < birthdaymd ? year - birthdayy : year - birthdayy;

  // alert(age);
  return age;
};

export const CheckUseableByKoreanAge = (servid, user) => {
  let value = false;

  if (
    user &&
    user.loginSuccess &&
    user.loginSuccess.result === 0 &&
    user.loginSuccess.birthday !== ""
  ) {
    const kAge = GetKoreanAge(user.loginSuccess.birthday);
    const ServiceData = GetServiceSetData(servid)[0];
    if (ServiceData && kAge >= ServiceData.SVC_LMTAGE) {
      value = true;
    }
  } else {
    value = true;
  }

  return value;
};

export const getCurrentPartyStatusStr = (status) => {
  // CPS_None    :           0,
  // CPS_Before  :           1,
  // CPS_Requested :      2,
  // CPS_ExitReady:        3,
  // CPS_Exited :             4,
  // CPS_BreakReady:     5,
  // CPS_Broken :            6,
  // CPS_Ended  :            7,
  // CPS_Using   :            8

  let str = "";
  switch (status) {
    case CPState.CPS_Before:
      str = GetStringByKey(200047);
      break;
    case CPState.CPS_Requested:
      str = GetStringByKey(200048);
      break;
    case CPState.CPS_ExitReady:
      str = GetStringByKey(200050);
      break;
    case CPState.CPS_Exited:
      str = GetStringByKey(200052);
      break;
    case CPState.CPS_BreakReady:
      str = GetStringByKey(200049);
      break;
    case CPState.CPS_Broken:
      str = GetStringByKey(200051);
      break;
    case CPState.CPS_Ended:
      str = GetStringByKey(200053);
      break;
    case CPState.CPS_Using:
      str = GetStringByKey(200046);
      break;

    default:
      break;
  }
  return str;
};

export const GetTimeFromUnixTime = (time) => {
  var date = new Date(time * 1000);
  var year = date.getFullYear();
  var month = "0" + (date.getMonth() + 1);
  var day = "0" + date.getDate();
  var hour = "0" + date.getHours();
  var minute = "0" + date.getMinutes();
  // var second = "0" + date.getSeconds();
  return (
    year +
    "." +
    month.substr(-2) +
    "." +
    day.substr(-2) +
    " " +
    hour.substr(-2) +
    ":" +
    minute.substr(-2)
  );
};

// 유효한 이메일 형식인지 체크
export const checkIsEmailType = (idValue) => {
  const emailRule =
    // /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i;
    /([\w-\.]+)@((?:[\w]+\.)+)([a-zA-Z]{2,4})/i;
  if (emailRule.test(idValue)) {
    // 유효한 이메일 형식이면 true
    return true;
  } else {
    // 유효하지 않으면 false
    return false;
  }
};

// 연장 가능한 파티인지 체크
export const checkIsExtendable = (partyInfoData, user) => {
  if (!partyInfoData || !user?.partyList) {
    return false;
  }

  const memberData = partyInfoData?.member;
  const childPid = partyInfoData?.party?.childpid;
  const partyData = partyInfoData?.party;

  const endDateForUI = moment(partyData.enddate).add(-1, "d")._d;

  // 파티 state
  const tState = partyData?.mystate ?? 8;

  // endSoon 파티인지
  const partyStatus = getServiceTakeableData(user?.partyList, partyData?.serv);

  // 파티 종료일까지 남은 날짜
  const remainDay = getDiffDay(moment(), endDateForUI);

  const plist = user?.partyList;

  let hasBeforeParty = false;
  if (
    plist?.party?.find(
      (data) =>
        data.serv === partyData.serv && data?.mystate === CPState.CPS_Before
    ) !== undefined
  ) {
    hasBeforeParty = true;
  }

  // 연장 가능 조건:
  // 1. 파티 멤버 수 >= 2 &&
  // 2. endSoon &&
  // 3. 3 < 남은 날짜 < 29 &&  -----------------> 3 < 남은날짜  조건은 0 <= 남은날짜로 변경 (2022.05.27)
  // 4. 파티중 &&
  // 5. childpid === 0
  if (
    memberData?.length >= 2 &&
    childPid === 0 &&
    tState === CPState.CPS_Using &&
    partyStatus?.status === "endSoon" &&
    0 <= remainDay &&
    remainDay < 29 &&
    !hasBeforeParty
  ) {
    return true;
  } else {
    return false;
  }
};

// 연장한 파티인지 체크
export const checkIsJustExtended = (partyInfoData) => {
  const parentPid = partyInfoData?.party?.parentpid;
  const partyData = partyInfoData?.party;

  // 파티 state
  const tState = partyData?.mystate ?? 8;

  if (
    getDiffDay(partyData?.joindate, moment()) < 2 &&
    parentPid !== 0 &&
    tState === CPState.CPS_Before
  ) {
    return true;
  } else {
    return false;
  }
};

export const encodeBase64 = (data) => {
  return ApiBase64.btoa(encodeURIComponent(data));
};
export const decodeBase64 = (data) => {
  return decodeURIComponent(ApiBase64.atob(data));
};

// 정산일 변경 가능한지 체크
export const checkIsPaydayChangeable = (partyList) => {
  let usingBeforePartyList = [];

  for (let i = 0; i < partyList.length; i++) {
    const state = partyList[i]?.mystate ?? 8;

    if (state === CPState.CPS_Using || state === CPState.CPS_Before) {
      usingBeforePartyList.push(partyList[i]);
    }
  }

  // 파티 중인 파티 리스트 + 미래 파티 리스트 > 0 ? 정산일 변경 x: 정산일 변경 ㅇ
  if (usingBeforePartyList?.length > 0) {
    return false;
  } else {
    return true;
  }
};

// 링키드 포인트 히스토리 적요
export const getPointTitleString = (lp_type) => {
  if (lp_type === 201) {
    return 200068; // 링키드 포인트 사용
  } else if (lp_type === 203) {
    return 200064; // 링키드 포인트 만료
  } else if (lp_type === 204) {
    return 200072; // 링키드 포인트 차감
  } else if (lp_type === 104) {
    return 200065; // 링키드 포인트 환불
  } else if (lp_type === 202) {
    return 200067; // 링키드 머니로 전환
  } else if (lp_type === 101 || lp_type === 102 || lp_type === 103) {
    return 200063; // 링키드 포인트 적립
  }
};

export const getThousandComma = (value) => {
  if (value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return value;
  }
};

export const getLPointShowValue = (value) => {
  let val = getThousandComma(value);
  return GetStringByKeyValues(40194, [{ target: "{lp_value}", value: val }]);
};

// 현재 월 구하기
export const getDateMonth = () => {
  const date = new Date();
  const month = date.getMonth() + 1;
  return month;
};

// byte에 따라 문자열 자르기
export const cutByteLength = (str, maxByte) => {
  let b, i, c;

  for (b = i = 0; (c = str.charCodeAt(i));) {
    b += c >> 7 ? 2 : 1;

    if (b > maxByte) break;

    i++;
  }

  return str.substring(0, i);
};

// 몇 byte인지 구하기
export const getByteLength = (str) => {
  return str
    .split("")
    .map((s) => s.charCodeAt(0))
    .reduce((prev, c) => prev + (c === 10 ? 2 : c >> 7 ? 2 : 1), 0);
};

// 버전 비교
export const diffVersion = (beforeVersion, nowVersion) => {
  // 0: equal / 1: beforeVersion > nowVersion / -1: beforeVersion < nowVersion
  const compare = beforeVersion.localeCompare(nowVersion, undefined, {
    numeric: true,
    sensitivity: "base",
  });

  return compare;
};

/** 맨 마지막 글자에 받침이 있는지 찾는 함수 */
export const isEndWithConsonant = (str) => {
  const korReg = /[ㄱ-ㅣ가-힣]/g;

  // 한글인 경우에만 체크
  if (korReg.test(str)) {
    const finalChrCode = str?.charCodeAt((str?.length ?? 0) - 1) ?? 0;
    // 0 = 받침 없음, 그 외 = 받침 있음
    const finalConsonantCode = (finalChrCode - 44032) % 28;
    return finalConsonantCode !== 0;
  } else {
    return true;
  }
};

/** 유플러스 파티 상태 스트링 */
export const uplusPartyStateStr = (status) => {
  switch (status) {
    case 1:
      return "매칭중";
    case 2:
      return "결합중";
    case 3:
      return "파티중";
    case 4:
      return "종료";

    default:
      return "";
  }
};
